const locale = document.querySelector('html').getAttribute('lang');
export default locale || 'de';


// WEBPACK FOOTER //
// ./themes/wild/assets/js/locale.js